function assert(condition, message) {
  if (process.env.VITE_FIREBASE_ENV !== 'production' && !condition)
    throw Error(message);
}

export default assert;
